export enum SystemCode {
  AFL = "AFL",
  AIR = "AIR",
  MTP = "MTP",
  MTPS = "MTPS",
  CPR = "CPR", //thay đổi bổ sung nhân sự khóa học
  EBM = "EBM", // bảng đăng ký khóa học
  EWR = "EWR", // xuất kho
  ETR = "ETR", // thu hồi CCDC
  SER = "SER", // BẢNG TỔNG HỢP NHÂN SỰ THAM GIA KHÓA HỌC
  MR = "MR", // đăng ký sử dụng phòng họp
  BC = "BCR", // In danh thiếp
  SR = "SR", // Đề nghị văn phòng phẩm
  DAC = "DAC", //Yêu cầu xoá tài khoản
  AMADEUS = "AMADEUS", //Yêu cầu cấp Amadeus
  ITR = "ITR", //IT Repair tool
  ITT = "ITT",
}
